"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSpinner = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledSpinner = styled_components_1.default.div `
  color: ${config_1.colors.blurple};
  height: 33px;
  margin-bottom: 15px;
  width: 33px;
`;
